import axios from 'axios';

import { getServiceUrl } from '../config';

export const updateObject = (oldObject, updatedValues) => {
  return {
    ...oldObject,
    ...updatedValues,
  };
};
